import { createFileRoute } from '@tanstack/react-router';
import { PurchaseOrdersList } from '@/app/(client)/orders/-components/PurchaseOrdersList';
import { purchaseOrdersQueryOptions } from '@/app/(client)/orders/-hooks/usePurchaseOrdersList';
import { queryClient } from '@/lib/utils/queryClient';

export const Route = createFileRoute(
  '/(client)/orders/(pages)/(list)/purchase-orders/active/',
)({
  validateSearch: (search: Record<string, unknown>) => ({
    aiSummaryId:
      typeof search.aiSummaryId === 'string' ? search.aiSummaryId : undefined,
    aiOrderNumber:
      typeof search.aiOrderNumber === 'string'
        ? search.aiOrderNumber
        : undefined,
    sort: typeof search.sort === 'string' ? search.sort : undefined,
  }),
  loader: () =>
    queryClient.ensureQueryData(
      purchaseOrdersQueryOptions({ page: 1, limit: 50, isArchived: false }),
    ),
  component: ActivePurchaseOrdersPage,
});

function ActivePurchaseOrdersPage() {
  return <PurchaseOrdersList isArchived={false} />;
}
